export default __webpack_public_path__ + "static/media/bK.ca7e6cc5.svg";